<script>
import options from './MenuSearch.options'
const componentOptions = options
export default componentOptions
</script>

<template>
    <nav ref="searchNavRef" class="be-menu-search" :class="{ 'be-menu-search--shown' : isActiveAction  }" :aria-label="labels.navSearchLabel">
        <div class="be-menu-search__content">
            <div class="be-menu-search__content-search-wrapper">
                <div class="be-menu-search__content-searchbar">
                    <span class="be-menu-search__content-icon">
                        <svg role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25">
                            <circle
                                cx="11.767"
                                cy="12.267"
                                r="8.989"
                                stroke="#1E2B24"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.5" />
                            <path
                                stroke="#1E2B24"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.5"
                                d="m18.019 18.985 3.524 3.515" />
                        </svg>
                    </span>

                    <input
                        ref="searchInputRef"
                        :aria-label="labels.searchLabel"
                        class="be-menu-search__content-input be-js--menu-search-item"
                        v-model="searchValue"
                        id="searchInput"
                        type="text"
                        autocomplete="off"
                        :placeholder="labels.searchPlaceholder"
                        v-on:keydown="handleKeyNavigation"
                        v-on:keydown.enter="handleSearch" />
                </div>

                <section class="be-menu-search__content-suggestions" :class="suggestionsClassname">
                    <template v-if="autoCompleteResults.length === 0">
                        <div class="be-menu-search__content-suggestions-heading">{{ labels.searchSuggestionsLabel }}</div>
                        <ul class="be-menu-search__content-suggestions-list">
                            <li class="be-menu-search__content-suggestions-item" v-for="item in suggestions" :key="item.id">
                                <a
                                    v-on:keydown="handleKeyNavigation"
                                    class="be-menu-search__content-suggestions-link be-js--menu-search-item"
                                    :href="item.url"
                                    >{{ item.label }}</a
                                >
                            </li>
                        </ul>
                    </template>
                    <template v-else>
                        <div class="be-menu-search__content-suggestions-heading">{{ labels.autoCompleteResultsLabel }}</div>
                        <ul class="be-menu-search__content-suggestions-list">
                            <li class="be-menu-search__content-suggestions-item" v-for="item in autoCompleteResults" :key="item.id">
                                <a
                                    v-on:keydown="handleKeyNavigation"
                                    class="be-menu-search__content-suggestions-link be-js--menu-search-item"
                                    :href="item.url"
                                    >{{ item.title }}</a
                                >
                            </li>
                        </ul>
                    </template>
                </section>
            </div>

            <div class="be-color-theme--white-green">
                <button v-on:keydown="handleKeyNavigation" class="be-btn be-js--menu-search-item" v-on:click="handleSearch">
                    {{ labels.buttonLabel }}
                </button>
            </div>
        </div>

        <div class="be-menu-search__mobile be-color-theme--white-green">
            <a
                ref="mobileSearchLinkRef"
                class="be-btn be-btn--outline be-js--menu-search-item"
                :href="redirecturl"
                >{{ labels.buttonLabel }}</a
            >
        </div>
    </nav>
</template>
